"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "11.22",
    height: "9",
    viewBox: "0 0 11.22 9"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.23,0a1,1,0,0,0-1,1V3.5H2V1A1,1,0,0,0,0,1V8A1,1,0,0,0,2,8V5.5H9.23V8a1,1,0,1,0,2,0V1A1,1,0,0,0,10.23,0Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;